
import SafeHome from "../../../assets/filled/SafeHome.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SafeHomeIcon({ className, dataTestid = "SafeHomeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SafeHome data-testid={dataTestid} className={classes} {...rest} />
  );
}
